// src/components/apps/SharePoint/DeleteConfirmDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

const DeleteConfirmDialog = ({ open, item, onClose, onConfirm, loading }) => {
  if (!item) return null;

  const isFolder = !!item.folder;
  const itemType = isFolder ? "folder" : "file";
  const warningText = isFolder
    ? "This will permanently delete the folder and all its contents."
    : "This will permanently delete the file.";

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningIcon color="warning" />
        Delete {itemType}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete <strong>{item.name}</strong>?
        </DialogContentText>
        <DialogContentText sx={{ mt: 1, color: "error.main" }}>
          {warningText} This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
